"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Language_1 = __importDefault(require("@mui/icons-material/Language"));
const material_1 = require("@mui/material");
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const decorators_1 = require("../../../common/decorators");
const material_2 = require("@mui/material");
const LanguagePickerModal_1 = __importDefault(require("../Modal/LanguagePickerModal"));
const SearchModal_1 = __importDefault(require("../Modal/SearchModal"));
const translations_1 = __importDefault(require("../../../common/translations"));
const react_router_dom_1 = require("react-router-dom");
const useIdleTimeout_1 = __importDefault(require("../../hooks/useIdleTimeout"));
const ButtonsContainer = styled_components_1.default.div `
  display: flex;
  gap: 10px;

  .search-button,
  .language-button {
    background: rgba(255, 255, 255, 0.9);
    border-radius: 100px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 2vmin;
    color: black;

    @media (max-width: 1280px) {
      p {
        display: none;
      }
    }

    @media (orientation: portrait) {
      p {
        display: none;
      }
    }
  }
`;
const SearchAndLanguage = ({ enabledLocales, currentLocale, isDialogOpen, updateStore }) => {
    const [isLanguageDialogOpen, setIsLanguageDialogOpen] = (0, react_1.useState)(false);
    const [isSearchDialogOpen, setIsSearchDialogOpen] = (0, react_1.useState)(false);
    const location = (0, react_router_dom_1.useLocation)();
    const isSubPage = location.pathname.includes('/overview/');
    const updateUserSelectedLocale = (selectedLocale) => {
        if (currentLocale === selectedLocale) {
            return;
        }
        localStorage.setItem('language', selectedLocale);
        updateStore('userSelectedLocale', selectedLocale);
    };
    (0, react_1.useEffect)(() => {
        if (isSubPage || isDialogOpen || isLanguageDialogOpen || isSearchDialogOpen) {
            updateStore('isCarouselPaused', true);
        }
        else {
            updateStore('isCarouselPaused', false);
        }
    }, [isSubPage, isDialogOpen, isLanguageDialogOpen, isSearchDialogOpen, updateStore]);
    const closeOpenOverlays = (0, react_1.useCallback)(() => {
        setIsLanguageDialogOpen(false);
        setIsSearchDialogOpen(false);
    }, []);
    (0, useIdleTimeout_1.default)(isLanguageDialogOpen || isSearchDialogOpen, closeOpenOverlays);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ButtonsContainer, { className: "buttons-container" },
            react_1.default.createElement(material_1.IconButton, { className: "language-button", onClick: () => setIsLanguageDialogOpen(true), id: "aqa_navigation_language", "aria-label": "Change language" },
                react_1.default.createElement(Language_1.default, null),
                react_1.default.createElement(material_2.Typography, null, translations_1.default.t('languages_label'))),
            react_1.default.createElement(material_1.IconButton, { className: "search-button", tabIndex: 0, onClick: () => setIsSearchDialogOpen(true), "aria-label": "Search content" },
                react_1.default.createElement(Search_1.default, null),
                react_1.default.createElement(material_2.Typography, null, translations_1.default.t('search')))),
        isSearchDialogOpen && react_1.default.createElement(SearchModal_1.default, { open: isSearchDialogOpen, onClose: () => setIsSearchDialogOpen(false) }),
        isLanguageDialogOpen && (react_1.default.createElement(LanguagePickerModal_1.default, { open: isLanguageDialogOpen, onClose: () => setIsLanguageDialogOpen(false), enabledLocales: enabledLocales, currentLocale: currentLocale, onLocaleSelect: updateUserSelectedLocale }))));
};
const mapStoreToProps = store => ({
    enabledLocales: store.getValue('enabledLocales'),
    currentLocale: store.getValue('currentLocale'),
    isDialogOpen: store.getValue('isDialogOpen'),
});
exports.default = (0, decorators_1.withStore)(mapStoreToProps)(SearchAndLanguage);
